import React from "react";
import { Helmet } from "react-helmet";

export default function SkipScreenshotFlag() {
  return (
    <Helmet>
      <meta name='x-go-screenshot' content='skip' />
    </Helmet>
  );
}
